angular.module( 'acme.view.application.pos.create.description', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.pos.create.description.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var posCreateDescription = {
        name: 'application.pos.create.description',
        url: '/description',
        views: {
          "subview-main": {
            controller: 'PosCreateDescriptionController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/pos/create/description/description.tpl.html'
          }
        },
        data: {
          pageTitle: 'Point of Sale Configurator'
        }
      },
      posEditDescription = {
        name: 'application.pos.edit.description',
        url: '/description',
        views: {
          "subview-main": {
            controller: 'PosCreateDescriptionController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/pos/create/description/description.tpl.html'
          }
        },
        data: {
          pageTitle: 'Point of Sale Configurator'
        }
      };

    $stateProvider
      .state(posCreateDescription)
      .state(posEditDescription);
});
